module.exports = __webpack_public_path__ + "img/customer-slide-left.8445a309.png";